"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusCircle = void 0;
var React = require("react");
var PlusCircle = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { height: "31", width: "31", viewBox: "0 0 31 31", xmlns: "http://www.w3.org/2000/svg", style: style },
        React.createElement("defs", null,
            React.createElement("path", { id: "PLUS-CIRCLE-PATH", d: "M15 26.25c6.213 0 11.25-5.037 11.25-11.25S21.213 3.75 15 3.75 3.75 8.787 3.75 15 8.787 26.25 15 26.25zM15 2.5c6.904 0 12.5 5.596 12.5 12.5S21.904 27.5 15 27.5 2.5 21.904 2.5 15 8.096 2.5 15 2.5zm6.25 11.806h-5.556V8.75h-1.388v5.556H8.75v1.388h5.556v5.556h1.388v-5.556h5.556v-1.388z" }),
            React.createElement("path", { id: "PLUS-CIRCLE-PATH-2", d: "M0 0H30V30H0z" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1", transform: "translate(.333)" },
            React.createElement("mask", { id: "PLUS-CIRCLE-MASK-B", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#PLUS-CIRCLE-PATH" })),
            React.createElement("g", { mask: "url(#PLUS-CIRCLE-MASK-B)" },
                React.createElement("mask", { id: "PLUS-CIRCLE-MASK-D", fill: "#fff" },
                    React.createElement("use", { xlinkHref: "#PLUS-CIRCLE-PATH-2" })),
                React.createElement("g", { fill: "#00242D", mask: "url(#PLUS-CIRCLE-MASK-D)", opacity: "0.25" },
                    React.createElement("path", { d: "M0 0H30V30H0z" }))))));
};
exports.PlusCircle = PlusCircle;
//# sourceMappingURL=PlusCircle.js.map